import { default as Account } from './Account';
import { default as Bookings } from './Bookings';
import { default as Calendar } from './Calendar';
import { default as ChatToUs } from './ChatToUs';
import { default as Direct } from './Direct';
import { default as FeesAndChannels } from './FeesAndChannels';
import { default as Home } from './Home';
import { default as LogOut } from './LogOut';
import { default as Messages } from './Messages';
import { default as More } from './More';
import { default as Properties } from './Properties';
import { default as Score } from './Score';
import { default as Support } from './Support';
const navIcons = {
    Account,
    Bookings,
    Calendar,
    ChatToUs,
    Direct,
    FeesAndChannels,
    Home,
    LogOut,
    Messages,
    More,
    Properties,
    Score,
    Support
};
/**
 * Navigation-specific iconography. The exported names of all nav ico
ns
 * are prefixed with "Nav." e.g. "Nav.Home".
 */
export default Object.keys(navIcons).reduce((navs, key) => (Object.assign(Object.assign({}, navs), { [`Nav.${key}`]: navIcons[key] })), {});
//# sourceMappingURL=index.js.map